import { getDateParts } from "../utils/common";
import { DateParts } from "../types/generalTypes";

/**
 * Bir tarih string'ini alıp formatlanmış tarih ve temel bileşenlerini döndüren hook
 * @param dateString ISO formatında tarih string'i veya Date nesnesi
 * @returns Formatlanmış tarih ve temel bileşenler
 */
export function useDateParts(dateString: string | Date): DateParts {
  // getDateParts fonksiyonunu kullanarak işlemleri gerçekleştir
  return getDateParts(dateString);
}
